import React, { forwardRef } from 'react';
import { SelectMenu } from '@spotoninc/nexus-react';
import { useMultiSelectionFilterDropdown } from './useMultiSelectionFilterDropdown';
import styles from './nexusFilterDropdown.module.css';

/**
 * NexusFilterDropdown component using Nexus React SelectMenu with custom styling
 * to match the appearance of the custom FilterDropdown component
 *
 * @param {Object} props - Component props
 * @param {string} props.label - Label text for the filter button
 * @param {Array} props.options - Array of option objects with value and label
 * @param {Array} props.value - Array of selected values (controlled)
 * @param {Array} props.initialValue - Initial selected values
 * @param {Function} props.onChange - Custom onChange handler
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.disabled - Whether the dropdown is disabled
 */
const NexusFilterDropdown = forwardRef(function NexusFilterDropdown(
  {
    label = 'Filter',
    options = [],
    value,
    initialValue = [],
    onChange,
    className = '',
    disabled = false,
    ...rest
  },
  ref
) {
  const {
    // State
    selectedValues,
    hasSelection,

    // Functions
    handleSelectionChange,
    getDisplayText,
  } = useMultiSelectionFilterDropdown({
    options,
    value,
    initialValue,
    onChange,
    disabled,
  });

  return (
    <div className={`${styles.nexusFilterDropdownContainer} ${className}`}>
      <SelectMenu
        ref={ref}
        value={selectedValues}
        initialValue={initialValue}
        onChange={handleSelectionChange}
        options={options}
        placeholder={label}
        multiple={true}
        disabled={disabled}
        className={`${styles.nexusFilterDropdown} ${hasSelection ? styles.hasSelection : ''}`}
        renderValue={() => label}
        {...rest}
      />
    </div>
  );
});

export default NexusFilterDropdown;
